import { GetVenuesByGeoQuery, SportsEnum } from 'types/generated/client';
import { FilterProps as CourtFinderFilterProps } from 'screens/CourtFinder/types';

export interface CourtListProps {
  venues: GetVenuesByGeoQuery['venues'];
  listHoveredVenueId: string | null;
  setListHoveredVenueId: React.Dispatch<React.SetStateAction<string | null>>;
  loading: boolean;
  /** Drives the default artwork for venues without a photo. */
  selectedSport: SportsEnum;
}

export interface CourtMapMarkerProps {
  listHoveredVenueId: string | null;
  setListHoveredVenueId: React.Dispatch<React.SetStateAction<string | null>>;
  setActiveVenueId: React.Dispatch<React.SetStateAction<string | null>>;
  activeVenue: GetVenuesByGeoQuery['venues'][0] | undefined;
  venue: GetVenuesByGeoQuery['venues'][0];
  /** Drives the default artwork for venues without a photo. */
  selectedSport?: SportsEnum;
}

/**
 * Two of the shared court-finder filter props are omitted rather than passed and ignored:
 *
 * - `showFreeCourts` — this modal's Free-courts switch drives the shared `accessType`
 *   array instead, so the boolean had no reader.
 * - `fetchCourts` — `useCourt` refetches from a `distance` effect now, so the modal no
 *   longer runs the query itself (and no longer needs the map centre to do it).
 *
 * Both still exist on `screens/CourtFinder/FilterBar`, which is why the shared
 * `FilterProps` keeps them.
 */
export interface CourtFiltersProps
  extends Omit<CourtFinderFilterProps, 'showFreeCourts' | 'setShowFreeCourts' | 'fetchCourts'> {
  courtLimit: number;
  /** Drives the tennis-only section hiding — see CourtFilters. */
  selectedSport: SportsEnum;
  distance: {
    name: string;
    id: number;
  };
  setDistance: (distance: { name: string; id: number }) => void;
}

export enum CourtType {
  Indoor = 'INDOOR',
  Outdoor = 'OUTDOOR',
}

export interface ExploreCourtsProps {
  resultsLimit?: number;
  initialSport?: SportsEnum;
}

export interface UseCourtReturn {
  CourtList: React.ReactElement;
  CourtFilters: React.ReactElement;
  courtMapProps: import('components/GoogleMap/props').GoogleMapProps;
  clearCourtFilters: () => void;
  distance: { name: string; id: number };
  setDistance: React.Dispatch<React.SetStateAction<{ name: string; id: number }>>;
  onAddressChange: ({ latitude, longitude }: { latitude: number; longitude: number }) => void;
  courtsLength: number;
  // Sports filtering
  selectedSport: SportsEnum;
  setSelectedSport: React.Dispatch<React.SetStateAction<SportsEnum>>;
  // UI state and handlers
  isModalOpen: boolean;
  openModal: () => void;
  closeModal: () => void;
  isOpenMap: boolean;
  handleToggleMap: () => void;
  discoverContainerRef: React.RefObject<HTMLDivElement>;
  isDiscoverSectionInView: boolean;
}
